import axios from "axios"
import { File } from "../models/file"
import { Service } from "../services/Service"

const serverBaseURL = process.env.REACT_APP_API_BASE_URL

class GedApi {
    public static async upload(
        formData: FormData,
        progress: (status: { progress: number }) => void,
        pathOption?: string
    ): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const queryParams = pathOption ? `?pathOption=${pathOption}` : ""

        const response = await axios.put(
            `${serverBaseURL}/ged${queryParams}`,
            formData,
            {
                headers,
                onUploadProgress: (data) => {
                    progress({
                        progress: Math.round((100 * data.loaded) / data.total),
                    })
                },
            }
        )
        if (response.status === 200) {
            return response.data
        }
        return response
    }

    public static async download(gedId: string): Promise<any> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.get(
            `${serverBaseURL}/ged/download/${gedId}`,
            {
                responseType: "blob",
                headers,
            }
        )
        return response.data
    }

    public static async list(): Promise<Array<File>> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.get(`${serverBaseURL}/ged/list`, {
            headers,
        })
        return response.data
    }

    public static async getMeta(fileId: string): Promise<File> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.get(
            `${serverBaseURL}/ged/meta/${fileId}`,
            {
                headers,
            }
        )
        return response.data
    }

    public static async getMetas(fileIds: string[]): Promise<File[]> {
        const headers = await Service.getRequestHeaders()
        if (Array.isArray(fileIds)) {
            const response = await axios.get(
                `${serverBaseURL}/ged/meta?ids=${fileIds.join(",")}`,
                {
                    headers,
                }
            )
            return response.data
        }
        return []
    }

    public static async update(
        fileId: string,
        formData: FormData
    ): Promise<void> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.post(
            `${serverBaseURL}/ged/${fileId}`,
            formData,
            {
                headers,
            }
        )
        return response.data
    }

    public static async delete(fileId: string): Promise<void> {
        const headers = await Service.getRequestHeaders()
        const response = await axios.delete(`${serverBaseURL}/ged/${fileId}`, {
            headers,
        })
        return response.data
    }
}
export default GedApi
